<template>
  <div class="panel">
    <div class="panel-heading">
      <h1 class="panel-title">应用</h1>
    </div>
    <div class="panel-body">
      <div class="app-warp">
        <div class="app-list" v-for="app in applications" :key="app.app_number">
          <a @click="goToApp(app.app_function_link)">
            <div class="icon-box">
              <img class="icon" :src="app.app_icon" />
            </div>
            <p>{{app.app_name}}</p>
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="drive-more clearfix">
      <span class="pull-right">
        <a>
          查看所有应用
          <i class="ti ti-angle-down"></i>
        </a>
      </span>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "Application",
  computed: {
    applications() {
      return this.$store.state.app.applications;
    }
  },
  methods: {
    goToApp (link) {
      if (link.startsWith('http')) {
        window.open(link)
      } else {
        this.$router.push({name: link})
      }
    }
  }
};
</script>

<style scoped>
</style>